/*
 * @Author: fengxiaojing
 * @LastEditTime: 2022-04-06 18:23:14
 * @Description: 计算相机视角偏移量
 * @LastEditors: Please set LastEditors
 */
/**
 * @description: 根据当前相机视角计算出与模型中心点的偏移量
 * @param {*} player
 * @param {*} documentId
 * @return {*}
 */
const calcOffset = async (player, documentId) => {
  // 获取模型信息
  const modelInfo = await PlayerUtils.call(player.Native.Model.getInfo, documentId)
  // 获取模型的空间坐标位置
  const modelPosistion = await PlayerUtils.call(
    player.Native.NodeProxy.globalTranslation,
    modelInfo.nodePtr
  )
  // 当前相机参数
  const cameraParam = await PlayerUtils.call(player.Native.Camera.currentParam)
  // 计算偏移量
  const offsetEye = Vec3.sub(cameraParam.eye, modelPosistion)
  const offsetTarget = Vec3.sub(cameraParam.target, modelPosistion)
  const up = cameraParam.up
  return {
    eye: offsetEye,
    target: offsetTarget,
    up: up,
  }
}
/**
 * @description:  获取position所在的相机位置
 * @param {*} player
 * @param {*} documentId
 * @param {*} position 模型的位置
 * @param {*} offset 模型偏移量
 * @param {*} isLoadMap 是否加载地球
 * @return {*}
 */
const restore = async (player, documentId, position, offset, isLoadMap = false) => {
  // 获取模型信息
  const modelInfo = await PlayerUtils.call(player.Native.Model.getInfo, documentId)
  // 获取模型的空间坐标位置
  const modelPosistion = await PlayerUtils.call(
    player.Native.NodeProxy.globalTranslation,
    modelInfo.nodePtr
  )
  let eye = position.eye
  let target = position.target
  let up = position.up
  //拿到模型的局部变换矩阵
  const modelLocalTransform = await PlayerUtils.call(
    player.Native.NodeProxy.localTransform,
    modelInfo.nodePtr
  )
  //从模型的局部变换矩阵中萃取旋转矩阵
  const modelLocalRotation = Matrix4.decompose(modelLocalTransform).rotation
  //将模型的旋转应用到定位参数偏移量
  eye = Matrix4.multiplyPos(modelLocalRotation, eye)
  target = Matrix4.multiplyPos(modelLocalRotation, target)
  up = Matrix4.multiplyPos(modelLocalRotation, up)
  if (isLoadMap) {
    // 有地球
    //使用当前模型位置转换为经纬高
    let modelLLH = await PlayerUtils.call(player.Native.GisPlatform.worldToLLH, modelPosistion)
    //使用经纬度查询当前真实高程
    const realH = await PlayerUtils.call(player.Native.GisPlatform.queryDEM, [
      [modelLLH[0], modelLLH[1]],
    ])
    //使用查询出来的真实高程,并且需要将地形攀爬偏移量加上
    modelLLH[2] = Number(realH) + Number(offset)
    //转换为模型的真实空间坐标位置，然后做相机定位计算
    const realModelPosition = await PlayerUtils.call(player.Native.GisPlatform.llhToWorld, modelLLH)
    //计算球上的某个位置对应的旋转矩阵
    const matRotate = await player.Native.GisPlatform.makeGisTransform(modelLLH)
    matRotate[12] = 0
    matRotate[13] = 0
    matRotate[14] = 0
    //计算球上该位置的旋转矩阵应用到定位参数偏移量
    eye = Matrix4.multiplyPos(matRotate, eye)
    target = Matrix4.multiplyPos(matRotate, target)
    up = Matrix4.multiplyPos(matRotate, up)
    //使用模型的真实空间坐标位置偏移定位参数偏移量
    eye = Vec3.add(realModelPosition, eye)
    target = Vec3.add(realModelPosition, target)
  } else {
    // 无地球
    //使用模型的真实空间坐标位置偏移定位参数偏移量
    eye = Vec3.add(modelPosistion, eye)
    target = Vec3.add(modelPosistion, target)
  }
  return {
    eye,
    target,
    up,
  }
}
export { calcOffset, restore }
